import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/components/email/EmParts";
import { STARTERS, buildStarter } from "@/lib/emailStarters";

export default function StarterGallery({ mode = "template", testId = "em-starters" }) {
  const nav = useNavigate();
  const [busy, setBusy] = useState("");
  const use = async (s) => {
    setBusy(s.key);
    try {
      const design = buildStarter(s, (await api.get("/email-marketing/brand")).data);
      if (mode === "campaign") {
        const { data } = await api.post("/email-marketing/campaigns", { name: `${s.name} ${new Date().toLocaleDateString()}`, subject: s.subject, design });
        nav(`/email-marketing/campaigns/${data.id}/design`);
      } else {
        const { data } = await api.post("/email-marketing/templates", { name: s.name, category: s.category, design });
        nav(`/email-marketing/templates/${data.id}`);
      }
    } catch (e) { toast.error(errMsg(e)); setBusy(""); }
  };
  return (
    <section className="space-y-2" data-testid={testId}>
      <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-slate-400"><Sparkles className="w-3.5 h-3.5 text-amber-500" />Start from a branded starter</p>
      <div className="grid sm:grid-cols-3 gap-3">{STARTERS.map((s) => (
        <div key={s.key} className="bg-white border border-slate-200 rounded-xl p-4 flex flex-col gap-2" data-testid={`${testId}-${s.key}`}>
          <p className="font-semibold text-slate-800">{s.name}</p>
          <p className="text-xs text-slate-500 flex-1">{s.description}</p>
          <Button size="sm" variant="outline" disabled={!!busy} onClick={() => use(s)} data-testid={`${testId}-use-${s.key}`}>
            {busy === s.key ? <Loader2 className="w-4 h-4 animate-spin" /> : mode === "campaign" ? "Start campaign" : "Use starter"}
          </Button>
        </div>))}</div>
      <p className="text-[11px] text-slate-400">Starters use your brand settings. Replace the [bracketed] text before sending; no offers or prices are added for you.</p>
    </section>
  );
}
